import { useAppContext } from "../libs/contextLib";
const logo =
  "https://myprotectall.com/wp-content/uploads/2023/09/PA-Logo-Horizonal-Blue.png";
function Success() {
  const { configureData } = useAppContext();
  const logoURL = configureData.theme?.logo || logo;
  return (
    <>
      <div className={`pagewrpaper successpage ${configureData.name}page`}>
        {/* <div className="header-top" style={{ backgroundColor: configureData.theme.primaryColor }}></div> */}
        <div
          className="banner-part"
          style={{
            backgroundImage: `linear-gradient(rgba(255,255,255,0.5), rgba(255,255,255,0.5)), url(${configureData.theme?.backgroundImage})`,
          }}
        >
          <div className="container d-flex flex-column flex-grow-1">
            <div className="row m-0 align-items-center">
              <div className="col-md-4">
                <img
                  src={logoURL}
                  alt="protectall"
                  style={{ maxWidth: "80%", maxHeight: "80%" }}
                />
                {/* <img src="image/logo-regency.png" alt="Regency Furniture" /> */}
              </div>
            </div>
            <div className="py-5 d-flex align-items-center justify-content-center flex-grow-1">
              <div className="col-md-10 mx-auto text-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  version="1.1"
                  width="100"
                  height="100"
                  x="0"
                  y="0"
                  viewBox="0 0 100 100"
                  class="success_icon mb-3"
                >
                  <g>
                    <path
                      fill="#09b285"
                      d="M94.115 59.61c-1.966-3.058-3.931-6.007-5.897-9.064-.436-.655-.436-1.092 0-1.747 1.966-2.948 3.822-5.897 5.788-8.845 2.293-3.494 1.092-6.88-2.84-8.299-3.275-1.201-6.551-2.511-9.827-3.712-.655-.219-.983-.656-.983-1.42-.109-3.603-.327-7.207-.546-10.701-.218-3.822-3.166-6.006-6.879-5.023-3.494.873-6.988 1.856-10.374 2.839-.764.218-1.2 0-1.747-.546-2.184-2.84-4.477-5.569-6.66-8.299-2.403-3.057-6.116-3.057-8.627 0-2.184 2.73-4.477 5.46-6.552 8.19-.546.764-1.092.873-1.965.655-3.385-.983-6.77-1.856-9.173-2.512-4.695-1.092-7.534.765-7.753 4.696-.218 3.603-.436 7.207-.546 10.92 0 .764-.327 1.091-.982 1.419L8.397 32.092c-3.495 1.42-4.587 4.805-2.512 7.971 1.966 3.058 3.931 6.006 5.897 9.063.436.656.436 1.092 0 1.857a269.837 269.837 0 0 0-6.006 9.281c-1.856 2.949-.655 6.443 2.62 7.753 3.386 1.31 6.88 2.62 10.265 3.931.764.219.983.655.983 1.42.109 3.494.546 6.88.546 10.373 0 3.495 3.057 6.661 7.316 5.351 3.385-1.092 6.77-1.856 10.155-2.84.655-.218 1.092-.108 1.529.547 2.293 2.839 4.477 5.569 6.77 8.408 2.511 3.057 6.115 3.057 8.517 0 2.293-2.84 4.477-5.57 6.77-8.408.437-.546.764-.765 1.529-.546 3.494.983 6.988 1.856 10.483 2.839 3.603.983 6.66-1.201 6.77-4.914.218-3.603.436-7.207.546-10.92 0-.873.436-1.2 1.092-1.419a370.716 370.716 0 0 0 9.936-3.822c3.495-1.747 4.587-5.241 2.512-8.408zM68.017 41.7l-21.839 21.84c-.546.545-1.31.982-2.075 1.091-.218 0-.546.11-.764.11-.983 0-2.075-.437-2.839-1.202l-8.954-8.954a3.954 3.954 0 0 1 0-5.569 3.954 3.954 0 0 1 5.569 0l6.115 6.115 19-19a3.954 3.954 0 0 1 5.569 0c1.747 1.529 1.747 4.04.218 5.57z"
                      opacity="1"
                      data-original="#09b285"
                      class=""
                    ></path>
                  </g>
                </svg>
                <h2 className="dark03 mb-3">Thank you for your purchase!</h2>

                <p className="font18 dark03 mb-3">
                  You will receive an email in the next 1-2 business days with
                  confirmation details and the plan terms and conditions. If you
                  do not see this information, please check your spam folder.
                </p>
                <h3>Now you can enjoy your furniture for years to come.</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Success;
